import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import HomeIcon from '@material-ui/icons/Home';
import FolderIcon from '@material-ui/icons/Folder';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import ComputerIcon from '@material-ui/icons/Computer';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import MemoryIcon from '@material-ui/icons/Memory';
import PlaylistPlayIcon from '@material-ui/icons/PlaylistPlay';
import DescriptionIcon from '@material-ui/icons/Description';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import { StudioUserChip, ProjectSwitcher } from '@internal/plugin-studio-home';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      // Skipped items
      nav.take('page:search'); // Using search modal instead
      nav.take('page:notifications'); // Using NotificationsSidebarItem manually instead

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {/* Which project the portal is scoped to (evkka / landing / perimeter / …). */}
            <ProjectSwitcher />
            <SidebarDivider />
            {/* Studio OS pages (studio-home plugin). Registered as routable pages but without
                nav-item extensions, so they are linked explicitly here. */}
            <SidebarItem icon={HomeIcon} to="/studio-home" text="Studio Home" />
            <SidebarItem icon={FolderIcon} to="/studio-projects" text="Projects" />
            <SidebarItem icon={ViewColumnIcon} to="/studio-work" text="Work" />
            <SidebarItem icon={ViewColumnIcon} to="/studio-workboard" text="Work Board" />
            <SidebarItem icon={ComputerIcon} to="/studio-workers" text="Workers" />
            <SidebarItem icon={AccountTreeIcon} to="/studio-workflows" text="Workflows" />
            <SidebarItem icon={DoneAllIcon} to="/studio-approvals" text="Approvals" />
            <SidebarItem icon={MemoryIcon} to="/studio-capacity" text="AI Capacity" />
            <SidebarItem icon={DescriptionIcon} to="/studio-documents" text="Documents" />
            <SidebarItem icon={PlaylistPlayIcon} to="/studio-playbooks" text="Playbooks" />
            <SidebarItem icon={SystemUpdateAltIcon} to="/studio-updates" text="Updates" />
            <SidebarItem icon={SettingsApplicationsIcon} to="/studio-administration" text="Administration" />
            <SidebarDivider />
            {nav.take('page:catalog')}
            {nav.take('page:scaffolder')}
            <SidebarDivider />
            <SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          {/* Signed-in Studio identity + Sign Out (Auth C), resolved by the Control Plane. */}
          <StudioUserChip />
          <SidebarDivider />
          <NotificationsSidebarItem />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:app-visualizer')}
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
